module.exports = "pegasus/assets/themelp1/small/28.png";